
import "./styles.scss"
import { observer } from 'mobx-react';
import { PPDWidgetPieChartGraph } from '../../components/PPDWidgetPieChartGraph';
import { PPDWidgetPieChartLegend } from '../../components/PPDWidgetPieChartLegend';
import { useStore } from 'shared/hooks';
import { PPDModal } from './../../../../../PPDModal';
import { IUnitValue } from 'shared/models';

type Props = {
    title: string;
    labels: string[];
    values: IUnitValue[];
    colors: string[];
    isOpen: boolean;
    onClose: () => void;
};

export const PPDWidgetPieChartModal = observer(({
    title,
    labels,
    values,
    colors,
    onClose,
    isOpen
}: Props) => {

    const store = useStore(() => ({
        activeIndex: null as null | number,
    }));

    return (
        <PPDModal isOpened={isOpen} onClose={onClose} className="ppd-widget-pie-chart-modal">
            <div className="ppd-widget-pie-chart-modal">
                <div className="ppd-widget-pie-chart-modal__content">
                    <div className="ppd-widget-pie-chart-modal__header">
                        <h3 className="ppd-widget-pie-chart-modal__title">{title}</h3>
                        <PPDWidgetPieChartGraph
                            labels={labels}
                            values={values.map(value => value.amount)}
                            colors={colors}
                            activeIndex={store.activeIndex}
                            mode="outline"
                            className="ppd-widget-pie-chart-modal__graph"
                        />
                    </div>
                    <div className="ppd-widget-pie-chart-modal__wrapper">
                        <PPDWidgetPieChartLegend
                            className="ppd-widget-pie-chart-modal__legend"
                            labels={labels}
                            values={values}
                            colors={colors}
                            onHover={(i) => store.set('activeIndex', i)}
                            onLeave={() => store.set('activeIndex', null)}
                        />
                    </div>
                </div>
            </div>
        </PPDModal>
    );
});
